import { render, staticRenderFns } from "./NewUserRegister.vue?vue&type=template&id=f2236bc2&scoped=true"
import script from "./NewUserRegister.vue?vue&type=script&lang=js"
export * from "./NewUserRegister.vue?vue&type=script&lang=js"
import style0 from "./NewUserRegister.vue?vue&type=style&index=0&id=f2236bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2236bc2",
  null
  
)

export default component.exports